import * as React from 'react';
import { IMaskInput } from 'react-imask';
import { styled } from '@mui/system';
import { StyledTextFieldGroup } from '../../components/shared/StyledTextFieldGroup';

const TextMaskPhoneNumber = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="(#00) 000-0000"
      definitions={{
        '#': /[1-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

const StyledMaskedInput = (props) => (
  <StyledTextFieldGroup
    {...props}
    InputProps={{
      inputComponent: TextMaskPhoneNumber,
    }}
  />
)

export default StyledMaskedInput;
